var map = {
	"./": 9,
	"./academy-local": 82,
	"./academy-local.js": 82,
	"./academy-preprod": 83,
	"./academy-preprod.js": 83,
	"./academy-prod": 84,
	"./academy-prod.js": 84,
	"./dev": 85,
	"./dev-v2": 86,
	"./dev-v2.js": 86,
	"./dev.js": 85,
	"./index": 9,
	"./index.js": 9,
	"./local": 87,
	"./local.js": 87,
	"./preprod": 88,
	"./preprod.js": 88,
	"./prod": 89,
	"./prod.js": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223;